import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLoginPage = location.pathname === '/';

  const handleSignOut = () => {
    localStorage.removeItem('authToken');
    navigate('/');
  };

  const handleHome = () => {
    navigate('/register');
  }; 

  // Update this path if you put the image under a different name or folder in `public/`
  const logoSrc = `${process.env.PUBLIC_URL}/logo1.jpeg`;

  const buttonStyle = {
    color: '#fff',
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '20px',
    px: 3,
    mx: 0.5,
    backgroundColor: 'rgba(255,255,255,0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.2)'
    }
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(to right, #1565c0, #1e88e5)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        py: 1
      }}
    >
      <Toolbar sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        {/* Layout: left (logo), center (title), right (buttons) */}
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {/* Left: Logo */}
          <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src={logoSrc}
              alt="JSS Logo"
              sx={{
                height: { xs: 68, sm: 46, md: 54 },
                width: 'auto',
                objectFit: 'contain',
                mr: 2,
                filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))'
              }}
            />
          </Box>

          {/* Center: Title */}
          <Box sx={{ flex: 1, textAlign: 'center' }}>
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
                fontWeight: 'bold',
                fontSize: {
                  xs: '0.9rem',
                  sm: '1.1rem',
                  md: '1.25rem'
                },
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              JSS INSTITUTE OF SPEECH AND HEARING, MYSORE – 570004
            </Typography>
          </Box>

          {/* Right: Buttons */}
          <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center' }}>
            {!isLoginPage && (
              <Box sx={{ display: 'flex' }}>
                <Button onClick={handleHome} sx={buttonStyle}>
                  Home
                </Button>
                <Button onClick={handleSignOut} sx={buttonStyle}>
                  Sign Out
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
